<template>
<div class="left_menu_style">
    <Menu active-name="1-3" theme="dark" width="100%" mode="vertical" @on-select="refreshInstance" :open-names="openList" accordion style="float: left;">
        <Submenu name="0" class="controller_btn">
            <template slot="title">
                <div class="logo_img">
                    <img v-if="showLeft && logoImg != ''" @click="refreshInstance('0,首页')" :src="logoImg" />
                    <img :class="{'toggle_img_open':showLeft,'toggle_img_close':!showLeft}" @click="toggleLeft" :src="toggleImg" />
                </div>
            </template>
        </Submenu>
        <Submenu class="menu_btn" :class="{'hiddenIcon':hiddenIcon}" v-if="roleList[item.code]" :name="item.code" v-for="(item,index) in menuList" :key="index">
            <template slot="title">
                <div class="left_picture" v-if="!showLeft">
                    <el-dropdown placement="right-start" :hide-on-click="false">
                        <span class="el-dropdown-link" :aria-readonly="!showLeft">
                            <img :src="item.icon" />
                        </span>
                        <el-dropdown-menu slot="dropdown" class="left_menu_dropdown">
                            <div class="left_menu_dropdown_name" style="padding-left: 10px;">{{item.name}}</div>
                            <Submenu class="three_menu" v-if="roleList[three.code]" :name="three.code" v-for="(three,threeInfo) in item.threeMenu" :key="threeInfo+'t'">
                                <template slot="title">{{three.name}}</template>
                                <MenuItem style="padding-left: 27px;" v-if="roleList[bottom.code]" :name="bottom.code+','+bottom.name" v-for="(bottom,bottomInfo) in three.bottomMenu" :key="bottomInfo+'b'">{{bottom.name}}</MenuItem>
                            </Submenu>
                            <MenuItem style="padding-left: 20px;" v-if="roleList[childItem.code]" :name="childItem.code+','+childItem.name" v-for="(childItem,info) in item.secondMenu" :key="'c'+info">{{childItem.name}}</MenuItem>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="left_picture" v-else><img :src="item.icon" /></div>
                <span v-if="showLeft" class="left_btn_menu">{{item.name}}</span>
            </template>
            <Submenu class="three_menu" v-if="roleList[three.code]" :name="three.code" v-for="(three,threeInfo) in item.threeMenu" :key="threeInfo+'t'" v-show="showLeft">
                <template slot="title">{{three.name}}</template>
                <MenuItem style="padding-left: 45px;" v-if="roleList[bottom.code]" :name="bottom.code+','+bottom.name" v-for="(bottom,bottomInfo) in three.bottomMenu" :key="bottomInfo+'b'">{{bottom.name}}</MenuItem>
            </Submenu>
            <!-- 下拉一级 -->
            <MenuItem style="padding-left: 38px;" v-show="showLeft" v-if="roleList[childItem.code]" :name="childItem.code+','+childItem.name" v-for="(childItem,info) in item.secondMenu" :key="'c'+info">{{childItem.name}}</MenuItem>
        </Submenu>
    </Menu>
</div>
</template>

<script>
export default {
    name: "StandardSysLeftMenu",
    data() {
        return {
            logoImg: '',
            showLeft: true,
            hiddenIcon: false,
            toggleImg: require('../../assets/image/hidden.png'),
            hiddenImg: require('../../assets/image/hidden.png'),
            showImg: require('../../assets/image/show.png'),
            customer: require('../../assets/image/customer.png'),
            office: require('../../assets/image/office.png'),
            outCall: require('../../assets/image/outCall.png'),
            manage: require('../../assets/image/manage.png'),
            monitor: require('../../assets/image/monitor.png'),
            jobOrder: require('../../assets/image/jobOrder.png'),
            know: require('../../assets/image/knowledge.png'),
            note: require('../../assets/image/menuNote.png'),
            reportForm: require('../../assets/image/reportForm.png'),
            system: require('../../assets/image/system.png'),
            user: require('../../assets/image/user.png'),
            screen: require('../../assets/image/screen.png'),
            ai: require('../../assets/image/AI.png'),
            unknown: require('../../assets/image/unknown.png'),
            quicklink:require('../../assets/image/quicklink.png'),
            roleList: JSON.parse(localStorage.getItem("roleList")),
            menuList: [{
                    'code': '4_1',
                    'name': '我的工作台',
                    'secondMenu': [{
                        'code': '4_2',
                        'name': '待回访客户'
                    }, {
                        'code': '4_3',
                        'name': '待回收客户'
                    }, {
                        'code': '4_5',
                        'name': '待呼叫'
                    }]
                },
                {
                    'code': '1_1',
                    'name': '客户管理',
                    'secondMenu': [{
                        'code': '1_3',
                        'name': '公海客户'
                    }, {
                        'code': '1_2',
                        'name': '全部客户'
                    }]
                },
                {
                    'code': '2_1',
                    'name': '呼出管理',
                    'secondMenu': [{
                        'code': '2_2',
                        'name': '呼出任务'
                    }, {
                        'code': '2_3',
                        'name': '呼出监控'
                    }]
                },
                //add ai menu
                {
                    'code': 'a_1',
                    'name': 'AI管理',
                    'secondMenu': [{
                        'code': 'a_2',
                        'name': 'AI流程设置'
                    }, {
                        'code': 'a_3',
                        'name': 'AI呼叫管理'
                    }, {
                        'code': 'a_4',
                        'name': 'AI技能组'
                    }, {
                        'code': 'a_5',
                        'name': 'AI通话记录'
                    }]
                },
                // 工单管理
                {
                    'code': 'b_1',
                    'name': '工单管理',
                    'secondMenu': [{
                        'code': 'b_2',
                        'name': '所有工单'
                    }, {
                        'code': 'b_3',
                        'name': '我的未完成工单'
                    }, {
                        'code': 'b_4',
                        'name': '待我确认的工单'
                    }, {
                        'code': 'b_5',
                        'name': '抄送给我的工单'
                    }, {
                        'code': 'b_6',
                        'name': '我创建的工单'
                    }, {
                        'code': 'b_7',
                        'name': '未分配的工单'
                    }, {
                        'code': 'b_8',
                        'name': '已分配的工单'
                    }, {
                        'code': 'b_9',
                        'name': '处理中的工单'
                    }, {
                        'code': 'b_a',
                        'name': '暂停的工单'
                    }, {
                        'code': 'b_b',
                        'name': '已完成的工单'
                    }, {
                        'code': 'b_c',
                        'name': '已关闭的工单'
                    }, {
                        'code': 'b_d',
                        'name': '回收站'
                    }]
                },
                {
                    'code': '5_1',
                    'name': '短信管理',
                    'secondMenu': [{
                        'code': '5_2',
                        'name': '短信发送'
                    }, {
                        'code': '5_3',
                        'name': '短信模板'
                    }, {
                        'code': '5_4',
                        'name': '短信记录'
                    }]
                },
                {
                    'code': '6_1',
                    'name': '知识库管理',
                    'secondMenu': [{
                        'code': '6_2',
                        'name': '知识总览'
                    }]
                },

                {
                    'code': '7_1',
                    'name': '监控管理',
                    'threeMenu': [{
                        'code': '7_2',
                        'name': '通话监控',
                        'bottomMenu': [{
                            'code': '7_2-1',
                            'name': '当前通话'
                        }, {
                            'code': '7_2-2',
                            'name': '总览'
                        }, {
                            'code': '7_2-3',
                            'name': '技能组监控'
                        }, {
                            'code': '7_2-4',
                            'name': '座席监控'
                        }]
                    }],
                    'secondMenu': [{
                        'code': '7_3',
                        'name': '未完成工单监控'
                    }],
                },

                {
                    'code': '8_1',
                    'name': '统计报表',
                    'threeMenu': [{
                            'code': '8_2',
                            'name': '明细报表',
                            'bottomMenu': [{
                                'code': '8_2-1',
                                'name': '通话记录'
                            }, {
                                'code': '8_2-2',
                                'name': '状态变化明细'
                            }, {
                                'code': '8_2-3',
                                'name': '满意度明细'
                            }, {
                                'code': '8_2-4',
                                'name': '未接来电'
                            }, {
                                'code': '8_2-5',
                                'name': '内线通话明细'
                            }, {
                                'code': '8_2-7',
                                'name': '语音留言'
                            }, {
                                'code': '8_2-6',
                                'name': '办公话单'
                            },{
                                'code': '8_2-8',
                                'name': '未推送话单'
                            },{
                                'code': '8_2-9',
                                'name': '会话明细'
                            },{
                                'code': '8_2-10',
                                'name': '会话留言'
                            }
                            ]
                        },
                        {
                            'code': '8_3',
                            'name': '通话统计',
                            'bottomMenu': [{
                                'code': '8_3-1',
                                'name': '通话总览'
                            }, {
                                'code': '8_3-2',
                                'name': '热线号码统计'
                            }, {
                                'code': '8_3-3',
                                'name': '座席通话统计'
                            }, {
                                'code': '8_3-4',
                                'name': '技能组通话统计'
                            }, {
                                'code': '8_3-5',
                                'name': '部门通话统计'
                            }, {
                                'code': '8_3-6',
                                'name': 'IVR统计'
                            }, {
                                'code': '8_3-7',
                                'name': '满意度统计'
                            }]
                        },
                        {
                            'code': '8_4',
                            'name': '图形报表',
                            'bottomMenu': [{
                                'code': '8_4-1',
                                'name': '座席通话量'
                            }, {
                                'code': '8_4-2',
                                'name': '技能组通话量'
                            }, {
                                'code': '8_4-3',
                                'name': '部门通话量'
                            }, {
                                'code': '8_4-4',
                                'name': '满意度评价'
                            }]
                        },
                      {
                        'code': '8_6',
                        'name': 'AI图形报表',
                        'bottomMenu': [{
                          'code': '8_6-1',
                          'name': '交互轮次统计'
                        }, {
                          'code': '8_6-2',
                          'name': '呼出质量统计'
                        }, {
                          'code': '8_6-3',
                          'name': '关注点统计'
                        }, {
                          'code': '8_6-4',
                          'name': '分类标签统计'
                        }]
                      },
                      // 工单统计
                      {
                        'code': '8_7',
                        'name': '工单统计',
                        'bottomMenu': [{
                          'code': '8_7-2',
                          'name': '客服工作量统计'
                        }, {
                          'code': '8_7-3',
                          'name': '工单类型统计'
                        },
                          //   {
                          //     'code': '8_7-4',
                          //     'name': '工单满意度统计'
                          // },
                          {
                            'code': '8_7-5',
                            'name': 'SLA服务等级统计'
                          }]
                      },
                        {
                            'code': '8_5',
                            'name': '大屏展示',
                            'bottomMenu': [{
                                'code': '8_5-1',
                                'name': '通话总览'
                            }, {
                                'code': '8_5-2',
                                'name': '座席职场'
                            }]
                        },
                    ]
                },
                {
                    'code': '10_1',
                    'name': '快速应用',
                    'secondMenu': []
                },
                {
                    'code': '3_1',
                    'name': '系统管理',
                    'threeMenu': [{
                        'code': '3_5',
                        'name': 'CTI配置',
                        'bottomMenu': [{
                            'code': '3_5-1',
                            'name': '热线号码'
                        }, {
                            'code': '3_5-2',
                            'name': '技能组'
                        }, {
                            'code': '3_5-3',
                            'name': 'IVR设置'
                        }, {
                            'code': '3_5-4',
                            'name': '语音文件'
                        }, {
                            'code': '3_5-5',
                            'name': 'VIP管理'
                        }]
                    },{
                        'code': '3_12',
                        'name': '会话配置',
                        'bottomMenu': [{
                            'code': '3_12-3',
                            'name': '导航菜单'
                        },{
                            'code': '3_12-2',
                            'name': '黑名单'
                        },{
                            'code': '3_12-1',
                            'name': '渠道管理'
                        },{
                            'code': '3_12-5',
                            'name': '参数配置'
                        },]
                    },
                    // 工单配置
                    {
                        'code': '3_d',
                        'name': '工单配置',
                        'bottomMenu': [{
                            'code': '3_d-1',
                            'name': '工单服务组'
                        },{
                            'code': '3_d-2',
                            'name': '工单扩展表单'
                        },{
                            'code': '3_d-3',
                            'name': '流程触发器'
                        },{
                            'code': '3_d-4',
                            'name': 'SLA'
                        },{
                            'code': '3_d-5',
                            'name': '工单参数配置'
                        },]
                    }],
                    'secondMenu': [{
                            'code': '3_2',
                            'name': '自定义设置'
                        },
                        {
                            'code': '3_9',
                            'name': '级联数据设置'
                        },
                        {
                            'code': '3_6',
                            'name': '时间定义'
                        },
                        {
                            'code': '3_7',
                            'name': '导入批次'
                        },
                        {
                            'code': '3_8',
                            'name': '导出批次'
                        },
                        {
                            'code': '3_11',
                            'name': '黑白名单'
                        },{ //移到这里
                            'code': '3_12-4',
                            'name': '快捷回复'
                        },
                        {
                            'code': '3_3',
                            'name': '基本配置'
                        },

                        {
                            'code': '3_4',
                            'name': '操作日志'
                        },
                        {
                            'code': '3_10',
                            'name': '已删除客户'
                        }
                    ]
                },
                {
                    'code': '9_1',
                    'name': '用户管理',
                    'secondMenu': [{
                        'code': '9_2',
                        'name': '角色管理'
                    }, {
                        'code': '9_3',
                        'name': '员工管理'
                    }, {
                        'code': '9_4',
                        'name': '部门管理'
                    },{
                        'code': '9_5',
                        'name': '通讯录'
                    },{
                        'code': '9_6',
                        'name': '公告管理'
                    }
                    ]
                },
            ],
            openList: ['1'],
            threeMenuForDisplay: [],
        }
    },
    methods: {
        toggleLeft: function () {
            this.$emit("changeLeft", true);
            let isCollapsed = localStorage.getItem("isCollapsed");
            if (isCollapsed == "false") {
                this.hiddenIcon = false;
                this.toggleImg = this.hiddenImg;
                this.showLeft = true;
            } else {
                this.hiddenIcon = true;
                this.toggleImg = this.showImg;
                this.showLeft = false;
            }
        },
        init: function () {
            let configInfo = JSON.parse(localStorage.getItem("configInfo"));

            for (let i = 0; i < this.menuList.length; i++) {
                let code = this.menuList[i].code;
                this.menuList[i].icon = this.unknown;
                if (code == '1_1') {
                    this.menuList[i].icon = this.customer;
                }
                if (code == '2_1') {
                    this.menuList[i].icon = this.outCall;
                }
                if (code == '3_1') {
                    this.menuList[i].icon =this.system;
                }
                if (code == '4_1') {
                    this.menuList[i].icon = this.office;
                    let waitVisitDays = configInfo.waitVisitDays;
                    let recoveryDays = configInfo.recoveryDays;
                    let waitVisitName = this.menuList[i].secondMenu[0].name;
                    let recoveryName = this.menuList[i].secondMenu[1].name;
                    if (waitVisitDays && waitVisitDays != "0") {
                        this.menuList[i].secondMenu[0].name = waitVisitDays + "天" + waitVisitName;
                    }
                    if (recoveryDays && recoveryDays != "0") {
                        this.menuList[i].secondMenu[1].name = recoveryDays + "天" + recoveryName;
                    }
                }
                if (code == '5_1') {
                    this.menuList[i].icon = this.note;
                }
                if (code == '6_1') {
                    this.menuList[i].icon = this.know;
                }
                if (code == '7_1') {
                    this.menuList[i].icon = this.monitor;
                }
                if (code == '8_1') {
                    this.menuList[i].icon = this.reportForm;
                }
                if (code == '9_1') {
                    this.menuList[i].icon = this.user;
                }
                if (code == '10_1') {
                    this.menuList[i].icon = this.quicklink;
                }
                // 大屏展示
                if (code == '8_5') {
                    this.menuList[i].icon = this.screen;
                }
                //add ai menu
                if (code == 'a_1') {
                    this.menuList[i].icon = this.ai;
                }

                if (code == '在线客服') {
                    this.menuList[i].icon = this.outCall;
                }
                if (code == 'b_1') {
                    this.menuList[i].icon = this.jobOrder;
                }

            }
        },
        refreshInstance: function (obj) {
            let code = obj.split(",")[0];
            let breadList = JSON.parse(localStorage.getItem("breadList"));
            let count = 0;
            if (breadList) {
                for (let i = 0; i < breadList.length; i++) {
                    let breadCode = breadList[i].code;
                    if (code == breadCode) {
                        count++;
                    }
                }
            }
            localStorage.setItem("resetLabel", "");
            if (count == 0 && code.indexOf("1_2") != -1) {
                let resetLabel = "-1";
                if (code.indexOf("/") != -1) {
                    resetLabel = code.split("/")[1];
                }
                localStorage.setItem("resetLabel", resetLabel);
            }
            this.$emit("showContent", obj);
        }
    },
    created() {
        let companyLogo = localStorage.getItem("companyLogo");
        if (companyLogo) {
            this.logoImg = companyLogo;
        }else{
            this.logoImg = require('@/assets/image/logo.png');
        }
        this.init();
        if (this.roleList['1_2']) {
            let typeList = JSON.parse(localStorage.getItem("customerType"));
            for (let i = 0; i < this.menuList.length; i++) {
                let code = this.menuList[i].code;
                if (code == "1_1") {
                    if (typeList) {
                        for (let k = 0; k < typeList.length; k++) {
                            let typeCode = "1_2" + "/" + typeList[k].id;
                            let param = {
                                code: typeCode,
                                name: typeList[k].dictValue
                            };
                            this.roleList[typeCode] = true;
                            this.menuList[i].secondMenu.push(param);
                        };
                    }
                    let serviceParam = {
                        'code': '1_5',
                        'name': '服务记录'
                    };
                    this.menuList[i].secondMenu.push(serviceParam);
                    //return false;
                }
            }
        }
        if(this.roleList['10_1']) {  //快速应用
            let quickList = JSON.parse(localStorage.getItem("quickApply"));
            for (let i = 0; i < this.menuList.length; i++) {
                let code = this.menuList[i].code;
                if (code == "10_1") {
                    if(quickList==""){
                                this.menuList[i].secondMenu=new Array();
                                this.menuList.splice(this.menuList.findIndex(item => item.code === code), 1);
                    }else if(quickList) {
                        for (let k = 0; k < quickList.length; k++) {
                            let typeCode = quickList[k].id;
                            let param = {
                                code: quickList[k].id,
                                name: quickList[k].name
                            };
                            this.roleList[typeCode] = true;
                            this.menuList[i].secondMenu.push(param);
                        };
                    }
                }
            }

        }
    }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/login/StandardSysLeftMenu.vue